export default "__VITE_ASSET__T4mwmzrJ__"